const ACTOR_DASHBOARD_ROUTES = {
  KPI_SUMMARY: "/actor-dashboard/kpi-summary",
  BATCH_REPORT: "/reports/dashboard-summary-batch",
  OVERVIEW_FALLBACK: "/main-dashboard/overview",
};

export default ACTOR_DASHBOARD_ROUTES;
